import React from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {Box, Typography} from '@mui/material'
import {PGButton} from '@progynyglobal/pg-ui-library'
import HTMLReactParser from 'html-react-parser'

import {ReactComponent as MenopauseFoundSvg} from '@progyny/assets/images/404-menopause.svg'
import {ReactComponent as NotFoundSvg} from '@progyny/assets/images/404-new.svg'
import {ReactComponent as PregnancyFoundSvg} from '@progyny/assets/images/404-pregnancy.svg'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'
import {useProductLine} from '@progyny/hooks/useProductLine'
import {RouteEnum, useRoutes} from '@progyny/routes'

interface NotFoundProps {}

const NotFoundPage: React.ComponentType<NotFoundProps> = () => {
  const {t} = useTranslation()
  const {getPath} = useRoutes()
  const history = useHistory()
  const {productLine} = useProductLine()

  return (
    <SimpleMessageContainer
      image={
        productLine === 'pregnancy_and_postpartum'
          ? PregnancyFoundSvg
          : productLine === 'menopause'
            ? MenopauseFoundSvg
            : NotFoundSvg
      }
      justfyContent='start'
      actionArea={
        <PGButton
          variant='contained'
          size='large'
          onClick={() => history.push(getPath(RouteEnum.HOME))}
          label={t('404_start_page')}
        />
      }
      message={
        <Box mt={3}>
          <Typography variant={'h1'} textAlign={'center'}>
            {t('404_something_is_missing')}
          </Typography>
          <Typography variant='body2' mt={2} textAlign={'center'}>
            {HTMLReactParser(t('404_we_could_not_find_what'))}
          </Typography>
        </Box>
      }
    />
  )
}

export default NotFoundPage
